






















import { Component, Prop, Vue } from 'vue-property-decorator'
import type { GrupoDoIndice } from '@/shareds/novidades/modelo'

@Component
export default class IndiceDaAtualizacao extends Vue {
	@Prop({ type: Array, required: true }) grupos!: GrupoDoIndice[]
	@Prop({ type: Number, default: null }) atual!: number | null
}
